<template>
  <v-dialog
    v-model="active"
    width="80%"
    persistent
  >
    <v-card
      v-if="evaluacionMedica && historiaClinica"
      color="primary"
    >
      <v-card-title>
        <div class="text-h6">
          Evaluacion medica
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="text-h5 font-weight-bold">
                Evaluación médica
              </div>
            </v-col>
            <v-col>
              <v-text-field
                v-model="evaluacionMedica.CatAgudezaVisual.title"
                label="Agudeza visual"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="evaluacionMedica.CatEstadoNutrional.title"
                label="Estado nutricional"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="evaluacionMedica.CatPterigion.title"
                label="Pterigión"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="evaluacionMedica.CatTipoTiroides.title"
                label="Tipo tiroides"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col colnpms="12">
              <v-row>
                <v-col>
                  <v-card
                    color="primary"
                    class="card"
                  >
                    <v-card-title>Enfermedades cronico degenerativas</v-card-title>
                    <v-card-text>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon v-if="evaluacionMedica.enfermedadesCardiovasculares">
                              mdi-check
                            </v-icon>
                            <v-icon v-else>
                              mdi-minus
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Enfermedades cardiovasculares</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon v-if="evaluacionMedica.enfermedadesMuscoesyOsteoten">
                              mdi-check
                            </v-icon>
                            <v-icon v-else>
                              mdi-minus
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>
                            Enfermedades musculoesqueléticas y osteotendinosas
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon v-if="evaluacionMedica.enfermedadesRespiratorias">
                              mdi-check
                            </v-icon>
                            <v-icon v-else>
                              mdi-minus
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Enfermedades respiratorias</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon v-if="evaluacionMedica.enfermedadesSistemaNervioso">
                              mdi-check
                            </v-icon>
                            <v-icon v-else>
                              mdi-minus
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Enfermedades del sistema nervioso</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon v-if="evaluacionMedica.enfermedadesTractoUrinario">
                              mdi-check
                            </v-icon>
                            <v-icon v-else>
                              mdi-minus
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Enfermedades del tracto urinario</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon v-if="evaluacionMedica.pielYAnexos">
                              mdi-check
                            </v-icon>
                            <v-icon v-else>
                              mdi-minus
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Piel y anexos</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon v-if="evaluacionMedica.hiperuricemia">
                              mdi-check
                            </v-icon>
                            <v-icon v-else>
                              mdi-minus
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Hiperuricemia</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>Antecedentes de traumatismos físicos</v-card-title>
                    <v-card-text>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon v-if="evaluacionMedica.amputaciones">
                              mdi-check
                            </v-icon>
                            <v-icon v-else>
                              mdi-minus
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Amputaciones</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon v-if="evaluacionMedica.fracturas">
                              mdi-check
                            </v-icon>
                            <v-icon v-else>
                              mdi-minus
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Fracturas</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>
                      <div class="text-h6">
                        Tatuajes
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <v-list class="transparent">
                        <v-list-item
                          v-for="(tatuaje, index) in tatuajes"
                          :key="index"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{ tatuaje.DESCRIPCION }}</v-list-item-title>
                            <v-list-item-subtitle>{{ tatuaje.ZONA }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionMedica.observaciones"
                label="Observaciones de evaluación médica"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                rows="8"
              />
            </v-col>
            <v-col cols="12">
              <v-divider />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="text-h5 font-weight-bold">
                Historia clínica
              </div>
            </v-col>
            <v-col>
              <v-text-field
                v-model="historiaClinica.fecha"
                label="Fecha de realización"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="historiaClinica.CatGrupoSanguineo.title"
                label="Grupo sanguíneo"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="historiaClinica.CatServicioMedico.title"
                label="Servicio médico con el que cuenta"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="4">
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>Incapacidades</v-card-title>
                    <v-card-text>
                      <div
                        v-if="historiaClinica.incapacidadVidaLaboral"
                        class="text-body-1"
                      >
                        Motivo: {{ historiaClinica.motivoIncapacidad }}
                      </div>
                      <div
                        v-else
                        class="text-body-1"
                      >
                        El evaluado no ha tenido incapacidades.
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>Accidente laboral</v-card-title>
                    <v-card-text v-if="accidenteLaboral.length > 0">
                      <div
                        v-if="accidenteLaboral[0].CatTiempo"
                        class="text-body-1"
                      >
                        Hace cuanto tiempo ocurrió: {{ accidenteLaboral[0].CatTiempo.title }}
                      </div>
                      <div class="text-body-1">
                        Descripción: {{ accidenteLaboral[0].descripcion }}
                      </div>
                      <div class="text-body-1">
                        Detalle de complicaciones derivadas:
                        {{ accidenteLaboral[0].detalleComplicacionesDerivadas }}
                      </div>
                    </v-card-text>
                    <v-card-text v-else>
                      <div class="text-body-1">
                        El evaluado no ha tenido accidentes laborales.
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="text-h6">
                    Antecedentes heredofamiliares
                  </div>
                  <v-list-item
                    v-for="(antecedente, index) in groupAntecedentesParentezcoByPatologicas"
                    :key="index"
                    two-line
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ antecedente.enfermedad }}</v-list-item-title>
                      <v-list-item-subtitle class="font-weight-bold">
                        {{ antecedente.familiares }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="text-h6">
                    Ejercicios que practica
                  </div>
                </v-col>
                <v-col
                  v-for="(deporte, index) in ejercicio"
                  :key="index"
                  cols="4"
                >
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>
                      {{ deporte.CatTipoEjercicio.title }}
                    </v-card-title>
                    <v-card-text>
                      <div class="text-body-1">
                        Frecuencia: {{ deporte.CatFrecuencia.title }}
                      </div>
                      <div class="text-body-1">
                        Tiempo: {{ deporte.CatTiempo.title }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="text-h6">
                    Tipo de dieta
                  </div>
                </v-col>
                <v-col
                  v-for="(dieta, index) in dietas"
                  :key="index"
                  cols="4"
                >
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>
                      {{ dieta.CatGrupoAlimentos.title }}
                    </v-card-title>
                    <v-card-text>
                      <div class="text-body-1">
                        Frecuencia: {{ dieta.CatFrecuencia.title }}
                      </div>
                      <div class="text-body-1">
                        Observaciones: {{ dieta.otra }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="vivienda.length > 0">
                <v-col cols="12">
                  <div class="text-h6">
                    Vivienda
                  </div>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="vivienda[0].CatTipoVivienda.title"
                    label="Tipo de vivienda"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="vivienda[0].noHabitaciones"
                    label="Número de habitaciones"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="vivienda[0].noHabitantes"
                    label="Número de habitaciones"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                  />
                </v-col>
              </v-row>
              <v-row v-if="vivienda.length > 0">
                <v-col>
                  <v-textarea
                    v-model="vivienda[0].materialesConstruccion"
                    label="Materiales con los que está construida la vivienda"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    rows="4"
                    no-resize
                  />
                </v-col>
                <v-col>
                  <v-textarea
                    v-model="vivienda[0].otrosEspacios"
                    label="Otros espacios"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    rows="4"
                    no-resize
                  />
                </v-col>
                <v-col>
                  <v-textarea
                    v-model="vivienda[0].observaciones"
                    label="Observaciones"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    rows="4"
                    no-resize
                  />
                </v-col>
                <v-col>
                  <v-list>
                    <v-list-item
                      v-for="(servicio, index) in vivienda[0].servicios"
                      :key="index"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ servicio.CatTipoServicio.title }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="text-h6">
                    Zoonosis
                  </div>
                </v-col>
                <v-col
                  v-for="(zoo, index) in zoonosis"
                  :key="index"
                  cols="4"
                >
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>
                      {{ zoo.CatTipoZoonosis.title }}
                    </v-card-title>
                    <v-card-text>
                      <div class="text-body-1">
                        Detalles: {{ zoo.detalle }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="text-h6">
                    Medicación actual
                  </div>
                </v-col>
                <v-col
                  v-for="(med, index) in medicacionActual"
                  :key="index"
                  cols="4"
                >
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>
                      {{ med.CatMedicamento.title }}
                    </v-card-title>
                    <v-card-text>
                      <div class="text-body-1">
                        Diagnóstico de tratamiento: {{ med.diagnosticoTratamiento }}
                      </div>
                      <div class="text-body-1">
                        Fecha inicio: {{ med.fechaInicio }}
                      </div>
                      <div class="text-body-1">
                        Fecha final: {{ med.fechaFinal }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="text-h6">
                    Exploración de regiones
                  </div>
                </v-col>
                <v-col
                  v-for="(region, index) in regionExploracion"
                  :key="index"
                  cols="4"
                >
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>
                      {{ region.CatRegion.title }}
                    </v-card-title>
                    <v-card-text>
                      <div class="text-body-1">
                        Diagnóstico: {{ region.diagnostico }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="audiciones.length > 0">
            <v-col cols="12">
              <div class="text-h6">
                Resultado de test auditivo
              </div>
              <v-card
                color="primary"
                class="card"
              >
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="audiciones[0].resultadoOidoDerecho"
                          label="Resultado oído izquierdo"
                          rounded
                          filled
                          dense
                          readonly
                          background-color="primary"
                          color="secondary"
                        />
                      </v-col>
                      <v-col>
                        <v-text-field
                          v-model="audiciones[0].resultadoOidoIzquierdo"
                          label="Resultado oído izquierdo"
                          rounded
                          filled
                          dense
                          readonly
                          background-color="primary"
                          color="secondary"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        v-for="(prueba, index) in audiciones[0].pruebas"
                        :key="index"
                      >
                        <v-card
                          class="card"
                          color="primary"
                        >
                          <v-card-title>{{ prueba.CatOido.title }}</v-card-title>
                          <v-card-text>
                            <div class="text-body-1">
                              Prueba: {{ prueba.CatPruebaOido.title }}
                            </div>
                            <div class="text-body-1">
                              Resultado: {{ prueba.resultado }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="agudezasVisuales.length > 0">
            <v-col cols="12">
              <div class="text-h6">
                Resultado de test de agudeza visual
              </div>
              <v-card
                color="primary"
                class="card"
              >
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="agudezasVisuales[0].resultado"
                          label="Resultado de test de agudeza visual"
                          rounded
                          filled
                          dense
                          readonly
                          background-color="primary"
                          color="secondary"
                        />
                        <v-text-field
                          v-model="agudezasVisuales[0].percepcionColores"
                          label="Percepción de colores"
                          rounded
                          filled
                          dense
                          readonly
                          background-color="primary"
                          color="secondary"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        v-for="(prueba, index) in agudezasVisuales[0].pruebas"
                        :key="index"
                      >
                        <v-card
                          class="card"
                          color="primary"
                        >
                          <v-card-title>{{ prueba.CatOjos.title }}</v-card-title>
                          <v-card-text>
                            <div class="text-body-1">
                              Prueba: {{ prueba.CatPruebaOjos.title }}
                            </div>
                            <div class="text-body-1">
                              Diagnóstico: {{ prueba.diagnostico }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="patologicos.length > 0">
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <div class="text-h6">
                    Información de toxicomanías
                  </div>
                </v-col>
                <v-col cols="4">
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>Consumo de alcohol</v-card-title>
                    <v-card-text>
                      <v-container v-if="patologicos[0].consumosAlcohol.length > 0">
                        <v-row>
                          <v-col cols="6">
                            <div class="text-subtitle-2">
                              Cantidad de consumo
                            </div>
                          </v-col>
                          <v-col
                            cols="6"
                            align="right"
                          >
                            <div class="text-subtitle-2 font-weight-bold">
                              {{ patologicos[0].consumosAlcohol[0].cantidad }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div class="text-subtitle-2">
                              Frecuencia
                            </div>
                          </v-col>
                          <v-col
                            cols="6"
                            align="right"
                          >
                            <div class="text-subtitle-2 font-weight-bold">
                              {{ patologicos[0].consumosAlcohol[0].CatFrecuencia.title }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div class="text-subtitle-2">
                              Tipo de bebida
                            </div>
                          </v-col>
                          <v-col
                            cols="6"
                            align="right"
                          >
                            <div class="text-subtitle-2 font-weight-bold">
                              {{ patologicos[0].consumosAlcohol[0].CatTipoBebida.title }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div class="text-subtitle-2">
                              Edad a la que inició consumo
                            </div>
                          </v-col>
                          <v-col
                            cols="6"
                            align="right"
                          >
                            <div class="text-subtitle-2 font-weight-bold">
                              {{ patologicos[0].consumosAlcohol[0].edadInicio }} años
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>Consumo de tabaco</v-card-title>
                    <v-card-text>
                      <v-container v-if="patologicos[0].consumosTabaco.length > 0">
                        <v-row>
                          <v-col cols="6">
                            <div class="text-subtitle-2">
                              Cantidad de consumo
                            </div>
                          </v-col>
                          <v-col
                            cols="6"
                            align="right"
                          >
                            <div class="text-subtitle-2 font-weight-bold">
                              {{ patologicos[0].consumosTabaco[0].cantidadConsumo }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div class="text-subtitle-2">
                              Frecuencia
                            </div>
                          </v-col>
                          <v-col
                            cols="6"
                            align="right"
                          >
                            <div class="text-subtitle-2 font-weight-bold">
                              {{ patologicos[0].consumosTabaco[0].CatFrecuencia.title }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div class="text-subtitle-2">
                              Edad a la que inició consumo
                            </div>
                          </v-col>
                          <v-col
                            cols="6"
                            align="right"
                          >
                            <div class="text-subtitle-2 font-weight-bold">
                              {{ patologicos[0].consumosTabaco[0].edadInicio }} años
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card
                    class="card"
                    color="primary"
                  >
                    <v-card-title>Consumo de drogas</v-card-title>
                    <v-card-text>
                      <v-list v-if="patologicos[0].drogas.length > 0">
                        <v-list-item
                          v-for="droga in patologicos[0].drogas"
                          :key="droga.idDrogas"
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ droga.CatDrogas.title }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              Última vez consumida el {{ droga.ultimoConsumo }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                              Cantidad consumida: {{ droga.cantidadConsumo }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                              Motivo de consumo: {{ droga.motivo }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="somatometria.length > 0">
            <v-col cols="12">
              <v-divider />
            </v-col>
            <v-col cols="12">
              <div class="text-h6">
                Somatometría
              </div>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="somatometria[0].talla"
                label="Talla"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="somatometria[0].peso"
                label="Peso"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="somatometria[0].imc"
                label="IMC"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="somatometria[0].frecuenciaCardiaca"
                label="Frecuencia cardíaca"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="somatometria[0].frecuenciaRespiratoria"
                label="Frecuencia respiratoria"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="somatometria[0].habitusExterior"
                label="Habitus exterior"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="somatometria[0].pa"
                label="PA"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="somatometria[0].pulso"
                label="Pulso"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="somatometria[0].ta"
                label="ta"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="somatometria[0].temperatura"
                label="Temperatura"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
          </v-row>
          <v-row v-if="patologicos.length > 0">
            <v-col cols="12">
              <v-divider />
            </v-col>
            <v-col cols="12">
              <div class="text-h6">
                Datos patólogicos
              </div>
            </v-col>
            <v-col cols="6">
              <v-textarea
                :value="patologicos[0].detalleQuirurgicos"
                label="Antecedentes de cirugías"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="4"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                :value="patologicos[0].detalleAlergias"
                label="Alergias"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="4"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                :value="patologicos[0].detalleHospitalizacion"
                label="Detalles de hospitalización"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="4"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                :value="patologicos[0].detalleRehabilitacionFisica"
                label="Detalles de rehabilitación física"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="4"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                :value="patologicos[0].detalleTerapiaPsicologica"
                label="Detalles de terapia psicológica"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="4"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                :value="patologicos[0].detalleTerapiaPsiquiatrica"
                label="Detalles de terapia psiquiatrica"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="4"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                :value="patologicos[0].detalleTransfucionales"
                label="Detalles de transfucionales"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="4"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-textarea
                :value="patologicos[0].ultimaVacuna"
                label="Última vacuna aplicada"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="4"
                no-resize
                readonly
              />
            </v-col>
          </v-row>
          <v-row v-if="patologicos.length > 0">
            <v-col cols="12">
              <v-card
                class="card"
                color="primary"
              >
                <v-card-title>
                  <div class="text-h6">
                    Consumo de medicamentos controlados
                  </div>
                </v-card-title>
                <v-card-text>
                  <v-list v-if="patologicos[0].medicamentosControlados.length > 0">
                    <v-list-item
                      v-for="medicamento in patologicos[0].medicamentosControlados"
                      :key="medicamento.idMedicamentoControlado"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ medicamento.CatMedicamento.title }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          Consume desde el {{ medicamento.fechaInicio }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          Detalle de dosis: {{ medicamento.dosisDetalle }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="interrogatorioAS.length > 0">
            <v-col cols="12">
              <v-divider />
            </v-col>
            <v-col cols="12">
              <div class="text-h6">
                Interrogatorio por aparatos y sistemas
              </div>
            </v-col>
            <v-col
              v-for="interrogatorio in interrogatorioAS"
              :key="interrogatorio.idInterrogatorioAS"
              cols="6"
            >
              <v-card
                class="card"
                color="primary"
              >
                <v-card-title>{{ interrogatorio.CatAparatoSistema.title }}</v-card-title>
                <v-card-text>
                  {{ interrogatorio.diagnostico }}
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-divider />
            </v-col>
            <v-col cols="12">
              <v-textarea
                :value="historiaClinica.observaciones"
                label="Observaciones"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="4"
                no-resize
                readonly
              />
              <v-textarea
                :value="historiaClinica.resultadoLaboratorioGabinete"
                label="Resultados de laboratorio y gabinete"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="4"
                no-resize
                readonly
              />
              <v-textarea
                :value="historiaClinica.diagnosticoMedico"
                label="Diagnóstico médico"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="4"
                no-resize
                readonly
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    active: {
      type: Boolean,
    },

    evaluacionMedica: {
      type: Object,
      required: true,
    },

    historiaClinica: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('accidenteLaboral', {
      accidenteLaboral: 'getAccidenteLaboral',
    }),

    ...mapGetters('antecedentesHeredoFamiliares', {
      antecedentesHeredoFamiliares: 'getAntecedentesHeredoFamiliares',
    }),

    ...mapGetters('ejercicio', {
      ejercicio: 'getEjercicio',
    }),

    ...mapGetters('tipoDieta', {
      dietas: 'getTipoDieta',
    }),

    ...mapGetters('vivienda', {
      vivienda: 'getViviendas',
    }),

    ...mapGetters('zoonosis', {
      zoonosis: 'getZoonosis',
    }),

    ...mapGetters('medicacionActual', {
      medicacionActual: 'getMedicacionActual',
    }),

    ...mapGetters('regionExploracion', {
      regionExploracion: 'getRegionExploracion',
    }),

    ...mapGetters('antecedentesAndrogenicos', {
      androgenicos: 'getAntecedentesAndrogenicos',
    }),

    ...mapGetters('antecedentesGinecoObstetricos', {
      gineco: 'getAntecedentesGinecoObstetricos',
    }),

    ...mapGetters('audiciones', {
      audiciones: 'getAudiciones',
    }),

    ...mapGetters('antecedentesPatologicos', {
      patologicos: 'getAntecedentesPatologicos',
    }),

    ...mapGetters('agudezasVisuales', {
      agudezasVisuales: 'getAgudezasVisuales',
    }),

    ...mapGetters('interrogatorioAS', {
      interrogatorioAS: 'getInterrogatorioAS',
    }),

    ...mapGetters('somatometria', {
      somatometria: 'getSomatometria',
    }),

    ...mapGetters('patologicas', {
      patologicas: 'getPatologicas',
    }),

    tatuajes() {
      if (this.evaluacionMedica.descripcionTatuajes.length > 0) {
        return JSON.parse(this.evaluacionMedica.descripcionTatuajes);
      } return [];
    },

    groupAntecedentesParentezcoByPatologicas() {
      const groupedAntecedentes = [];

      this.patologicas.forEach((enfermedadPatologica) => {
        const familiaresWithEnfermedad = this.getFamiliaresWithEnfermedad(enfermedadPatologica);
        if (familiaresWithEnfermedad !== '') {
          groupedAntecedentes.push({
            enfermedad: enfermedadPatologica.title,
            familiares: familiaresWithEnfermedad,
          });
        }
      });

      return groupedAntecedentes;
    },
  },

  methods: {
    closeDialog() {
      this.$emit('close');
    },

    getFamiliaresWithEnfermedad(enfermedadPatologica) {
      const filteredAntecedentes = this.antecedentesHeredoFamiliares.filter(
        (antecedente) => antecedente.fk_idCatPatologicas === enfermedadPatologica.id,
      );

      const familiares = [];

      filteredAntecedentes.forEach((antecedente) => {
        familiares.push(antecedente.CatParentesco.title);
      });

      return familiares.join(', ');
    },
  },
};
</script>
